import { render, staticRenderFns } from "./SyncService.vue?vue&type=template&id=781d109a"
import script from "./SyncService.vue?vue&type=script&lang=js"
export * from "./SyncService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781d109a')) {
      api.createRecord('781d109a', component.options)
    } else {
      api.reload('781d109a', component.options)
    }
    module.hot.accept("./SyncService.vue?vue&type=template&id=781d109a", function () {
      api.rerender('781d109a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SyncService.vue"
export default component.exports